import type { WbsClient } from '@bldsoft/cappie/api/wbs'
import type { API } from '@setplex/tria-api'
import type { AdapterDefaults } from '../../index.h'

import { payload } from '@bldsoft/cappie/rest'
import * as v from 'valibot'
import { SubscriptionSchema } from './schemas'

export function use(
  client: WbsClient,
  subscriptions: API['subscriptions'],
  _api: API,
  _defaults: AdapterDefaults
): void {
  // GET /v3/subscriptions/current
  subscriptions.getCurrentSubscriptionFx.use(async () => {
    const json = await payload(client.get.api.v3.subscriptions.current())
    return v.parse(SubscriptionSchema, json)
  })
}
